module.exports = __webpack_public_path__ + "static/media/rock-dark.e9462230.png";